export default {
      id: "heart-fill-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "ico/gefera/sprite.svg#heart-fill",
      toString: function () {
        return this.url;
      }
    }